export const fastplay_dialogue = (t) => ({
	FASTPLAY_DIALOGUE_TITLE: {
		value: t('fastSpinDialog.title'),
		config: {
			fill: '#9A98EA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 38
		}
	},
	FASTPLAY_DIALOGUE_TEXT_1: {
		value: t('fastSpinDialog.text1'),
		config: {
			fill: '#FFFFFF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 26
		}
	},
	FASTPLAY_DIALOGUE_TEXT_2: {
		value: t('fastSpinDialog.text2'),
		config: {
			fill: '#FFFFFF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 26
		}
	},
	FASTPLAY_DIALOGUE_FAST_PLAY: {
		value: t('fastSpinDialog.fastPlay'),
		config: {
			fill: '#9A98EA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 26
		}
	},
	FASTPLAY_DIALOGUE_FAST_PLAY_SM: {
		value: t('fastSpinDialog.fastPlay'),
		config: {
			fill: '#9A98EA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20
		}
	},
	FASTPLAY_DIALOGUE_NOTE: {
		value: t('fastSpinDialog.dialogNote'),
		config: {
			fill: '#FFFFFF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20
		}
	},
	FASTPLAY_DIALOGUE_NOTE_END: {
		value: t('fastSpinDialog.noteEnd'),
		config: {
			fill: '#FFFFFF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20
		}
	},
	FASTPLAY_DIALOGUE_TOGGLE: {
		value: t('fastSpinDialog.toggleLabel'),
		config: {
			fill: '#FFFFFF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 26
		}
	},
	FASTPLAY_DIALOGUE_BTN: {
		value: t('fastSpinDialog.confirmBtn'),
		config: {
			fill: '#FFFFFF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	}
});
